import { useRecoilValue } from "recoil"

import { brandingSelector } from "src/recoil/atoms/room"
import {
  AvatarDimensionality,
  gridSelectedAvatarAtom,
  gridSelectedAvatarDimensionalityAtom
} from "src/recoil/atoms/avatars"
import {
  AvatarConfig,
  AvatarGesture,
  AvatarVideoSize
} from "src/recoil/atoms/avatars/types"
import useConfig, { Configs } from "src/hooks/useConfig"

const getAvatarConfig = (
  digitalAvatar: string | undefined,
  platformName: Configs["platformName"]
) => {
  // Default value
  let userSelectedAvatar: AvatarConfig = {
    avatarId: digitalAvatar ?? "",
    avatarName: "AI Digital Teacher",
    avatarDescription: "",
    gesture: AvatarGesture.move,
    videoSize: AvatarVideoSize.sixteenByNine,
    useDebugUrl: false,
    languages: []
  }
  const readLocalAvatar =
    platformName === "Utta" || platformName === "LearnMachine"
  const localStoredAvatar = readLocalAvatar
    ? localStorage.getItem("avatarConfig")
    : null
  // Get the avatar config from the local storage
  if (localStoredAvatar && localStoredAvatar !== "undefined")
    userSelectedAvatar = JSON.parse(localStoredAvatar) as AvatarConfig
  return userSelectedAvatar
}

/**
 *  A hook to get the current avatar information.
 */
const useCurrentAvatarInfo = () => {
  const { platformName } = useConfig()
  const gridSelectedAvatar = useRecoilValue(gridSelectedAvatarAtom)
  const roomStyles = useRecoilValue(brandingSelector)
  const dimensionality = useRecoilValue(gridSelectedAvatarDimensionalityAtom)

  const avatarConfig =
    gridSelectedAvatar ??
    getAvatarConfig(roomStyles?.digitalAvatar, platformName)

  const isAvatar3D =
    dimensionality == AvatarDimensionality.threeDimensional
      ? avatarConfig.gesture3d === AvatarGesture.move
      : avatarConfig.gesture === AvatarGesture.move

  // save the last loaded value to local storage
  localStorage.setItem("lastUsedAvatarConfig", JSON.stringify(avatarConfig))
  localStorage.setItem(
    "lastUsedAvatarDimensionality",
    JSON.stringify(isAvatar3D)
  )

  return {
    ...avatarConfig,
    isAvatar3D,
    avatarId2d: avatarConfig.avatarId,
    avatarId:
      dimensionality == AvatarDimensionality.threeDimensional
        ? avatarConfig.avatarId3d
        : avatarConfig.avatarId,
    gesture:
      dimensionality == AvatarDimensionality.threeDimensional
        ? avatarConfig.gesture3d
        : avatarConfig.gesture,
    videoSize:
      dimensionality == AvatarDimensionality.threeDimensional
        ? avatarConfig.videoSize3d
        : avatarConfig.videoSize
  }
}

export default useCurrentAvatarInfo
